import { render } from "./CIS-Media-Masthead.vue?vue&type=template&id=ef3a4e5a&scoped=true"
import script from "./CIS-Media-Masthead.vue?vue&type=script&lang=js"
export * from "./CIS-Media-Masthead.vue?vue&type=script&lang=js"

import "./CIS-Media-Masthead.vue?vue&type=style&index=0&id=ef3a4e5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3a4e5a"]])

export default __exports__